import VueCookies from "vue-cookies";

export default {
    isKey(key) {
        var value = false;
        if (navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined") {
            // 手機
            var storage = window.localStorage;
            if (storage.getItem(key)) {
                value = true;
            } else {
                value = false;
            }
        } else {
            // 網頁
            value = $cookies.isKey(key);
        }
        return value;
    },
    get(key) {
        var value = "";
        if (navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined") {
            // 手機
            var storage = window.localStorage;
            value = storage.getItem(key);
        } else {
            // 網頁
            value = $cookies.get(key);
        }
        return value;
    },
    set(key, value) {
        if (navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined") {
            // 手機
            var storage = window.localStorage;
            storage.setItem(key, value)
        } else {
            // 網頁
            $cookies.set(key, value, "1y", "/", location.hostname, "", "Lax");
        }
        return true;
    },
    set(key, value, time) {
        if (navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined") {
            // 手機
            var storage = window.localStorage;
            storage.setItem(key, value)
        } else {
            // 網頁
            $cookies.set(key, value, time, "/", location.hostname, "", "Lax");
        }
        return true;
    },
    setSiteLanguage(value, time) {
        if (navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined") {
            window.localStorage.setItem("ek_site_lang", value);
        } else {
            var hostname = location.hostname.toLowerCase();
            var cookieDomain = hostname;

            // men-go2.tpass.tw and men-go2.tpass.tw must use the same cookie scope. If one
            // cookie is scoped to the parent domain and another to www, browsers
            // send both values and vue-cookies may read the older one.
            if (hostname == "men-go2.tpass.tw" || hostname.endsWith(".men-go2.tpass.tw")) {
                cookieDomain = "men-go2.tpass.tw";
            }

            // Remove legacy host-only/current-host cookies before writing the
            // single shared language cookie. The parent-domain cookie is then
            // overwritten by the set call below.
            $cookies.remove("ek_site_lang", "/");
            $cookies.remove("ek_site_lang", "/", hostname);

            if (cookieDomain != hostname) {
                $cookies.remove("ek_site_lang", "/", cookieDomain);
            }

            $cookies.set("ek_site_lang", value, time || "30d", "/", cookieDomain, "", "Lax");
        }
        return true;
    },
    remove(key) {
        if (navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null && typeof cordova != "undefined") {
            // 手機
            var storage = window.localStorage;
            storage.removeItem(key)
        } else {
            // 網頁
            $cookies.remove(key, "/", location.hostname);
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/utils/storage.js